export const convertFromStringToBool = (val?: string): boolean => {
  return val === undefined ? false : val.toLowerCase() === 'true';
};
